import React from 'react'
import { Input } from 'components/fields'

const normalize = (value, prevValue) => {
  return (
    isNaN(value)
    || value.toString().indexOf(' ') > -1
    || value.toString().indexOf('.') > -1
    || value < 0
  )
    ? Number(prevValue) || 0
    : Number(value)
}

function InputPositive(props) {
  return <Input {...props} normalize={normalize} />
}

export default InputPositive
